
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.8.1
 * Query Engine version: 78caf6feeaed953168c64e15a249c3e9a033ebe2
 */
Prisma.prismaVersion = {
  client: "5.8.1",
  engine: "78caf6feeaed953168c64e15a249c3e9a033ebe2"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.TenantScalarFieldEnum = {
  id: 'id',
  name: 'name',
  plan: 'plan',
  subdomain: 'subdomain',
  hasLogo: 'hasLogo',
  supportEmail: 'supportEmail',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  fullName: 'fullName',
  imageUrl: 'imageUrl',
  phone: 'phone',
  birthday: 'birthday',
  country: 'country',
  address: 'address',
  fiscalCode: 'fiscalCode',
  languages: 'languages',
  role: 'role',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  locale: 'locale'
};

exports.Prisma.WorkplaceScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tenantId: 'tenantId'
};

exports.Prisma.UserToWorkplaceScalarFieldEnum = {
  userId: 'userId',
  workplaceId: 'workplaceId',
  tenantId: 'tenantId'
};

exports.Prisma.ZoneScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tenantId: 'tenantId'
};

exports.Prisma.UserToZoneScalarFieldEnum = {
  userId: 'userId',
  zoneId: 'zoneId',
  tenantId: 'tenantId'
};

exports.Prisma.PropertyScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  name: 'name',
  type: 'type',
  position: 'position',
  public: 'public',
  portals: 'portals',
  shortStays: 'shortStays',
  mediumStays: 'mediumStays',
  licenseNumber: 'licenseNumber',
  licenseDate: 'licenseDate',
  radarUser: 'radarUser',
  radarPassword: 'radarPassword',
  precinctRegistrationUser: 'precinctRegistrationUser',
  precinctRegistrationPassword: 'precinctRegistrationPassword',
  regionalIdCode: 'regionalIdCode',
  address: 'address',
  postcode: 'postcode',
  stairway: 'stairway',
  apartment: 'apartment',
  compartments: 'compartments',
  intercom: 'intercom',
  floor: 'floor',
  floorType: 'floorType',
  buildingFloors: 'buildingFloors',
  windowOrientation: 'windowOrientation',
  instructions: 'instructions',
  cadastralSheet: 'cadastralSheet',
  cadastralMap: 'cadastralMap',
  cadastralParticle: 'cadastralParticle',
  cadastralSubordinate: 'cadastralSubordinate',
  cadastralCategory: 'cadastralCategory',
  cadastralClass: 'cadastralClass',
  cadastralIncome: 'cadastralIncome',
  cadastralType: 'cadastralType',
  intendedUse: 'intendedUse',
  energyClass: 'energyClass',
  wifiUser: 'wifiUser',
  wifiPassword: 'wifiPassword',
  routerLocation: 'routerLocation',
  heatingType: 'heatingType',
  waterHeatingType: 'waterHeatingType',
  lightMeterLocation: 'lightMeterLocation',
  gasMeterLocation: 'gasMeterLocation',
  waterMeterLocation: 'waterMeterLocation',
  electricPanelLocation: 'electricPanelLocation',
  publicTransportDistance: 'publicTransportDistance',
  nearPOI: 'nearPOI',
  anomalies: 'anomalies',
  stayCostMedium: 'stayCostMedium',
  ownerPrice: 'ownerPrice',
  ownerFeeMedium: 'ownerFeeMedium',
  ownerFeeShort: 'ownerFeeShort',
  cleaningCostShort: 'cleaningCostShort',
  cleaningCostMedium: 'cleaningCostMedium',
  cleaningNetCostShort: 'cleaningNetCostShort',
  cleaningNetCostMedium: 'cleaningNetCostMedium',
  condoExpense: 'condoExpense',
  heatingExpense: 'heatingExpense',
  utilityFee: 'utilityFee',
  location: 'location',
  furnished: 'furnished',
  description: 'description',
  conditions: 'conditions',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt'
};

exports.Prisma.PropertyToUserScalarFieldEnum = {
  userId: 'userId',
  propertyId: 'propertyId',
  tenantId: 'tenantId'
};

exports.Prisma.PropertyToZoneScalarFieldEnum = {
  propertyId: 'propertyId',
  zoneId: 'zoneId',
  tenantId: 'tenantId'
};

exports.Prisma.PropertyFacilitiesScalarFieldEnum = {
  tv: 'tv',
  dvd: 'dvd',
  gas: 'gas',
  oven: 'oven',
  safe: 'safe',
  dryer: 'dryer',
  hiFi: 'hiFi',
  stove: 'stove',
  garage: 'garage',
  juicer: 'juicer',
  porter: 'porter',
  shower: 'shower',
  stereo: 'stereo',
  towels: 'towels',
  balcony: 'balcony',
  bathtub: 'bathtub',
  heating: 'heating',
  jacuzzi: 'jacuzzi',
  laundry: 'laundry',
  parking: 'parking',
  terrace: 'terrace',
  toaster: 'toaster',
  babyCot: 'babyCot',
  elevator: 'elevator',
  bedLinen: 'bedLinen',
  cdPlayer: 'cdPlayer',
  hairDryer: 'hairDryer',
  microwave: 'microwave',
  assistance: 'assistance',
  dishwasher: 'dishwasher',
  frontYard: 'frontYard',
  noSmoking: 'noSmoking',
  condominium: 'condominium',
  electricity: 'electricity',
  coffeePress: 'coffeePress',
  petsAllowed: 'petsAllowed',
  satelliteTv: 'satelliteTv',
  waterKettle: 'waterKettle',
  swimmingPool: 'swimmingPool',
  fridgeFreezer: 'fridgeFreezer',
  privateGarden: 'privateGarden',
  vacuumCleaner: 'vacuumCleaner',
  centralHeating: 'centralHeating',
  electricKettle: 'electricKettle',
  washingMachine: 'washingMachine',
  airConditioning: 'airConditioning',
  bedLinenTowels: 'bedLinenTowels',
  espressoMachine: 'espressoMachine',
  carParkingExtra: 'carParkingExtra',
  wirelessInternet: 'wirelessInternet',
  autonomousHeating: 'autonomousHeating',
  ironIroningBoard: 'ironIroningBoard',
  highSpeedInternet: 'highSpeedInternet',
  maintenanceService: 'maintenanceService',
  kitchenUtensilsProvided: 'kitchenUtensilsProvided',
  maidServiceUponRequest: 'maidServiceUponRequest',
  concierge: 'concierge',
  propertyId: 'propertyId'
};

exports.Prisma.PropertyImageScalarFieldEnum = {
  id: 'id',
  index: 'index',
  caption: 'caption',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tenantId: 'tenantId',
  propertyId: 'propertyId'
};

exports.Prisma.RoomTypeScalarFieldEnum = {
  id: 'id',
  name: 'name',
  cmId: 'cmId',
  cmHotelId: 'cmHotelId',
  capacity: 'capacity',
  squareMeters: 'squareMeters',
  bedrooms: 'bedrooms',
  restrooms: 'restrooms',
  doubleBeds: 'doubleBeds',
  singleBeds: 'singleBeds',
  doubleSofaBeds: 'doubleSofaBeds',
  singleSofaBeds: 'singleSofaBeds',
  pricePerMonth: 'pricePerMonth',
  pricePerNight: 'pricePerNight',
  deposit: 'deposit',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  tenantId: 'tenantId',
  propertyId: 'propertyId'
};

exports.Prisma.RoomScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  tenantId: 'tenantId',
  roomTypeId: 'roomTypeId'
};

exports.Prisma.BookingScalarFieldEnum = {
  id: 'id',
  cmId: 'cmId',
  checkIn: 'checkIn',
  checkOut: 'checkOut',
  duration: 'duration',
  source: 'source',
  customerType: 'customerType',
  checkInTime: 'checkInTime',
  checkOutTime: 'checkOutTime',
  status: 'status',
  pendingReason: 'pendingReason',
  rejectionReason: 'rejectionReason',
  blockReason: 'blockReason',
  ownerFee: 'ownerFee',
  guestFee: 'guestFee',
  portalFee: 'portalFee',
  cleaningCost: 'cleaningCost',
  utilityCost: 'utilityCost',
  deposit: 'deposit',
  cityTax: 'cityTax',
  adults: 'adults',
  children: 'children',
  receivedAt: 'receivedAt',
  receiverId: 'receiverId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  tenantId: 'tenantId',
  userId: 'userId',
  guestId: 'guestId',
  propertyId: 'propertyId'
};

exports.Prisma.BookedRoomScalarFieldEnum = {
  bookingId: 'bookingId',
  roomId: 'roomId',
  amount: 'amount',
  cmRate: 'cmRate',
  tenantId: 'tenantId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BookingPaymentScalarFieldEnum = {
  month: 'month',
  depositExpected: 'depositExpected',
  depositActual: 'depositActual',
  depositMethod: 'depositMethod',
  depositReturnExpected: 'depositReturnExpected',
  depositReturnActual: 'depositReturnActual',
  depositReturnMethod: 'depositReturnMethod',
  stayExpected: 'stayExpected',
  stayActual: 'stayActual',
  stayMethod: 'stayMethod',
  utilityExpected: 'utilityExpected',
  utilityActual: 'utilityActual',
  utilityMethod: 'utilityMethod',
  cleaningExpected: 'cleaningExpected',
  cleaningActual: 'cleaningActual',
  cleaningMethod: 'cleaningMethod',
  cityTaxExpected: 'cityTaxExpected',
  cityTaxActual: 'cityTaxActual',
  cityTaxMethod: 'cityTaxMethod',
  extraExpected: 'extraExpected',
  extraActual: 'extraActual',
  extraMethod: 'extraMethod',
  tenantId: 'tenantId',
  bookingId: 'bookingId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.GuestScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  fullName: 'fullName',
  birthdate: 'birthdate',
  fiscalCode: 'fiscalCode',
  address: 'address',
  country: 'country',
  region: 'region',
  languages: 'languages',
  phone: 'phone',
  email: 'email',
  gender: 'gender',
  birthPlace: 'birthPlace',
  docType: 'docType',
  docNumber: 'docNumber',
  docPlace: 'docPlace',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tenantId: 'tenantId'
};

exports.Prisma.AuctionScalarFieldEnum = {
  id: 'id',
  closedAt: 'closedAt',
  expiration: 'expiration',
  location: 'location',
  dateFrom: 'dateFrom',
  dateTo: 'dateTo',
  flexibleDates: 'flexibleDates',
  priceFrom: 'priceFrom',
  priceTo: 'priceTo',
  adults: 'adults',
  children: 'children',
  bedrooms: 'bedrooms',
  restrooms: 'restrooms',
  minSquareMeters: 'minSquareMeters',
  furnished: 'furnished',
  amenities: 'amenities',
  notes: 'notes',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AuctionBidScalarFieldEnum = {
  id: 'id',
  status: 'status',
  price: 'price',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  auctionId: 'auctionId',
  tenantUserId: 'tenantUserId',
  tenantId: 'tenantId',
  bookingId: 'bookingId'
};

exports.Prisma.CustomerScalarFieldEnum = {
  id: 'id',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  fullName: 'fullName',
  phone: 'phone',
  country: 'country',
  languages: 'languages',
  requestDate: 'requestDate',
  type: 'type',
  source: 'source',
  message: 'message',
  propertyType: 'propertyType',
  action: 'action',
  lastContactDate: 'lastContactDate',
  availability: 'availability',
  followUp: 'followUp',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tenantId: 'tenantId',
  contactedById: 'contactedById',
  zoneId: 'zoneId'
};

exports.Prisma.ContractScalarFieldEnum = {
  id: 'id',
  filename: 'filename',
  expiration: 'expiration',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  tenantId: 'tenantId',
  propertyId: 'propertyId',
  guestId: 'guestId',
  bookingId: 'bookingId',
  userId: 'userId'
};

exports.Prisma.NoteScalarFieldEnum = {
  id: 'id',
  title: 'title',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tenantId: 'tenantId',
  authorId: 'authorId',
  parentNoteId: 'parentNoteId',
  propertyId: 'propertyId',
  bookingId: 'bookingId',
  customerId: 'customerId',
  taskId: 'taskId',
  bookingRequestId: 'bookingRequestId'
};

exports.Prisma.NoteFileScalarFieldEnum = {
  id: 'id',
  name: 'name',
  extension: 'extension',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tenantId: 'tenantId',
  noteId: 'noteId'
};

exports.Prisma.FavoriteScalarFieldEnum = {
  userId: 'userId',
  propertyId: 'propertyId',
  savedAt: 'savedAt'
};

exports.Prisma.NotificationScalarFieldEnum = {
  id: 'id',
  event: 'event',
  readAt: 'readAt',
  createdAt: 'createdAt',
  tenantId: 'tenantId',
  tenantUserId: 'tenantUserId',
  userId: 'userId',
  bookingId: 'bookingId',
  auctionId: 'auctionId'
};

exports.Prisma.ChatScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  tenantId: 'tenantId',
  userId: 'userId',
  bookingId: 'bookingId',
  lastMessageAt: 'lastMessageAt'
};

exports.Prisma.TaskScalarFieldEnum = {
  id: 'id',
  type: 'type',
  description: 'description',
  hourly: 'hourly',
  hours: 'hours',
  cost: 'cost',
  fee: 'fee',
  refund: 'refund',
  payer: 'payer',
  payed: 'payed',
  datetime: 'datetime',
  extra: 'extra',
  tenantId: 'tenantId',
  propertyId: 'propertyId',
  bookingId: 'bookingId',
  assigneeId: 'assigneeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.TenantPlan = exports.$Enums.TenantPlan = {
  BASIC: 'BASIC',
  PREMIUM: 'PREMIUM',
  BUSINESS: 'BUSINESS'
};

exports.UserRole = exports.$Enums.UserRole = {
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  RECEIVER: 'RECEIVER',
  OWNER: 'OWNER',
  OPERATOR: 'OPERATOR'
};

exports.Language = exports.$Enums.Language = {
  IT: 'IT',
  EN: 'EN',
  ES: 'ES'
};

exports.PropertyType = exports.$Enums.PropertyType = {
  APARTMENT: 'APARTMENT',
  BNB: 'BNB'
};

exports.Location = exports.$Enums.Location = {
  ROME: 'ROME',
  MILAN: 'MILAN',
  BOLOGNA: 'BOLOGNA',
  BARCELONA: 'BARCELONA',
  TENERIFE: 'TENERIFE',
  CUBA: 'CUBA',
  BERGAMO: 'BERGAMO',
  BRESCIA: 'BRESCIA',
  COMO: 'COMO',
  CREMONA: 'CREMONA',
  LECCO: 'LECCO',
  LODI: 'LODI',
  MANTUA: 'MANTUA',
  MONZA: 'MONZA',
  PAVIA: 'PAVIA',
  SONDRIO: 'SONDRIO',
  VARESE: 'VARESE',
  CAGLIARI: 'CAGLIARI',
  NUORO: 'NUORO',
  ORISTANO: 'ORISTANO',
  SASSARI: 'SASSARI',
  AREZZO: 'AREZZO',
  FLORENCE: 'FLORENCE',
  GROSSETO: 'GROSSETO',
  LIVORNO: 'LIVORNO',
  LUCCA: 'LUCCA',
  MASSA_CARRARA: 'MASSA_CARRARA',
  PISA: 'PISA',
  PISTOIA: 'PISTOIA',
  PRATO: 'PRATO',
  SIENA: 'SIENA',
  FROSINONE: 'FROSINONE',
  LATINA: 'LATINA',
  RIETI: 'RIETI',
  VITERBO: 'VITERBO',
  FERRARA: 'FERRARA',
  FORLI_CESENA: 'FORLI_CESENA',
  MODENA: 'MODENA',
  PARMA: 'PARMA',
  PIACENZA: 'PIACENZA',
  RAVENNA: 'RAVENNA',
  REGGIO_EMILIA: 'REGGIO_EMILIA',
  RIMINI: 'RIMINI',
  AOSTA: 'AOSTA',
  AGRIGENTO: 'AGRIGENTO',
  CALTANISSETTA: 'CALTANISSETTA',
  CATANIA: 'CATANIA',
  ENNA: 'ENNA',
  MESSINA: 'MESSINA',
  PALERMO: 'PALERMO',
  RAGUSA: 'RAGUSA',
  SYRACUSE: 'SYRACUSE',
  TRAPANI: 'TRAPANI',
  BARI: 'BARI',
  BARLETTA_ANDRIA_TRANI: 'BARLETTA_ANDRIA_TRANI',
  BRINDISI: 'BRINDISI',
  FOGGIA: 'FOGGIA',
  LECCE: 'LECCE',
  TARANTO: 'TARANTO',
  CATANZARO: 'CATANZARO',
  COSENZA: 'COSENZA',
  CROTONE: 'CROTONE',
  REGGIO_CALABRIA: 'REGGIO_CALABRIA',
  VIBO_VALENTIA: 'VIBO_VALENTIA',
  BELLUNO: 'BELLUNO',
  PADUA: 'PADUA',
  ROVIGO: 'ROVIGO',
  TREVISO: 'TREVISO',
  VENICE: 'VENICE',
  VERONA: 'VERONA',
  VICENZA: 'VICENZA'
};

exports.Portal = exports.$Enums.Portal = {
  BOOKING: 'BOOKING',
  AIRBNB: 'AIRBNB',
  EXPEDIA: 'EXPEDIA',
  HOMEAWAY: 'HOMEAWAY',
  SPOTAHOME: 'SPOTAHOME',
  ERASMUSU: 'ERASMUSU',
  HOUSING: 'HOUSING',
  ZAPPYRENT: 'ZAPPYRENT',
  BEESPRINT: 'BEESPRINT',
  ISR: 'ISR',
  UNIPLACES: 'UNIPLACES',
  UNKNOWN: 'UNKNOWN',
  HALLDIS: 'HALLDIS',
  ROOMLESS: 'ROOMLESS',
  KOLUMBOOS: 'KOLUMBOOS',
  HOSTELWORLD: 'HOSTELWORLD'
};

exports.BookingCustomerType = exports.$Enums.BookingCustomerType = {
  B2B: 'B2B',
  B2C: 'B2C'
};

exports.BookingStatus = exports.$Enums.BookingStatus = {
  BLOCKED: 'BLOCKED',
  CANCELLED: 'CANCELLED',
  CONFIRMED: 'CONFIRMED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED'
};

exports.PaymentMethod = exports.$Enums.PaymentMethod = {
  CASH: 'CASH',
  CREDIT_CARD: 'CREDIT_CARD',
  CUSTOM: 'CUSTOM',
  TRANSFER: 'TRANSFER',
  PAYPAL: 'PAYPAL',
  VIRTUAL_CARD: 'VIRTUAL_CARD',
  EXEMPTION: 'EXEMPTION',
  PORTAL: 'PORTAL',
  UNKNOWN: 'UNKNOWN'
};

exports.Gender = exports.$Enums.Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE'
};

exports.DocType = exports.$Enums.DocType = {
  ID: 'ID',
  PASSPORT: 'PASSPORT'
};

exports.AuctionBidStatus = exports.$Enums.AuctionBidStatus = {
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  ACCEPTED: 'ACCEPTED'
};

exports.CustomerType = exports.$Enums.CustomerType = {
  MANAGER: 'MANAGER',
  MULTIOWNER: 'MULTIOWNER',
  OTHER_TYPE: 'OTHER_TYPE',
  OWNER: 'OWNER',
  PARTNER: 'PARTNER'
};

exports.CustomerSource = exports.$Enums.CustomerSource = {
  EMAIL: 'EMAIL',
  FACEBOOK: 'FACEBOOK',
  FORM: 'FORM',
  NUMBER: 'NUMBER',
  OTHER_SOURCE: 'OTHER_SOURCE',
  REFERRAL: 'REFERRAL',
  WEBSITE: 'WEBSITE'
};

exports.NotificationEvent = exports.$Enums.NotificationEvent = {
  NEW_BOOKING: 'NEW_BOOKING',
  AUCTION_BID_ACCEPTED: 'AUCTION_BID_ACCEPTED',
  AUCTION_BID_REJECTED: 'AUCTION_BID_REJECTED',
  NEW_AUCTION_BID: 'NEW_AUCTION_BID',
  AUCTION_EXPIRED: 'AUCTION_EXPIRED',
  BOOKING_CONFIRMED: 'BOOKING_CONFIRMED',
  BOOKING_REJECTED: 'BOOKING_REJECTED'
};

exports.TaskType = exports.$Enums.TaskType = {
  CHECK_IN: 'CHECK_IN',
  CHECK_OUT: 'CHECK_OUT',
  CLEANING: 'CLEANING',
  MAINTENANCE: 'MAINTENANCE',
  INSPECTION: 'INSPECTION',
  OFFICE: 'OFFICE',
  OTHER: 'OTHER'
};

exports.TaskPayer = exports.$Enums.TaskPayer = {
  OWNER: 'OWNER',
  GUEST: 'GUEST',
  COMPANY: 'COMPANY'
};

exports.Prisma.ModelName = {
  Tenant: 'Tenant',
  User: 'User',
  Workplace: 'Workplace',
  UserToWorkplace: 'UserToWorkplace',
  Zone: 'Zone',
  UserToZone: 'UserToZone',
  Property: 'Property',
  PropertyToUser: 'PropertyToUser',
  PropertyToZone: 'PropertyToZone',
  PropertyFacilities: 'PropertyFacilities',
  PropertyImage: 'PropertyImage',
  RoomType: 'RoomType',
  Room: 'Room',
  Booking: 'Booking',
  BookedRoom: 'BookedRoom',
  BookingPayment: 'BookingPayment',
  Guest: 'Guest',
  Auction: 'Auction',
  AuctionBid: 'AuctionBid',
  Customer: 'Customer',
  Contract: 'Contract',
  Note: 'Note',
  NoteFile: 'NoteFile',
  Favorite: 'Favorite',
  Notification: 'Notification',
  Chat: 'Chat',
  Task: 'Task'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://github.com/prisma/prisma/issues`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
